"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHexBytes = exports.isHexString = void 0;
const HEX_REGEX = /^(0x)[0-9a-f]+$/i;
/**
 * Check that string starts with 0x and has only valid hex symbols
 * @param val
 */
function isHexString(val) {
    return HEX_REGEX.test(val.toLowerCase());
}
exports.isHexString = isHexString;
/**
 * Check that string is valid hex with 0x prefix and length is even
 * @param val
 */
function isHexBytes(val) {
    return isHexString(val) && val.length % 2 === 0;
}
exports.isHexBytes = isHexBytes;
//# sourceMappingURL=validations.js.map